import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import palette from '@theme/palette';
import moment from 'moment';
import { Stack } from '@mui/material';
import { Tooltip } from '@shared/ui';
import { FiberManualRecord, SaveAlt } from '@shared-app/ui/icons';
import { ValColumnEnum } from '@shared-app/lib/types';
export const ValidationColumns = (handleDwgDownload) => [
    {
        label: 'Project title',
        id: ValColumnEnum.project_title,
        align: 'left',
        sortable: true,
        minWidth: 200,
        color: palette.primary.text,
        fontWeight: 500
    },
    {
        label: 'Date',
        id: ValColumnEnum.date,
        align: 'right',
        sortable: true,
        minWidth: 200,
        color: palette.primary.text,
        fontWeight: 500,
        format: value => moment(value).format('DD-MM-YYYY')
    },
    {
        label: 'Office country',
        id: ValColumnEnum.office_country,
        align: 'left',
        sortable: true,
        minWidth: 200,
        color: palette.primary.text,
        fontWeight: 500
    },
    {
        label: 'Office location',
        id: ValColumnEnum.office_location,
        align: 'left',
        sortable: true,
        minWidth: 250,
        color: palette.primary.text,
        fontWeight: 500
    },
    {
        label: 'System',
        id: ValColumnEnum.systems,
        align: 'left',
        sortable: true,
        minWidth: 200,
        color: palette.primary.text,
        fontWeight: 500,
        format: (val) => {
            if (!Array.isArray(val) || val.length === 0)
                return '';
            return val
                .map(system => system.charAt(0).toUpperCase() + system.slice(1).toLowerCase())
                .join(', ');
        }
    },
    {
        label: 'Type',
        id: ValColumnEnum.types,
        align: 'left',
        sortable: true,
        minWidth: 200,
        color: palette.primary.text,
        fontWeight: 500,
        format: (val) => {
            if (!Array.isArray(val) || val.length === 0)
                return '';
            return val.map(type => type.charAt(0).toUpperCase() + type.slice(1).toLowerCase()).join(', ');
        }
    },
    {
        label: 'Drawing file name',
        id: ValColumnEnum.drawing_file_name,
        align: 'left',
        sortable: true,
        minWidth: 250,
        color: palette.primary.text,
        fontWeight: 500
    },
    {
        label: 'Drawing number',
        id: ValColumnEnum.drawing_number,
        align: 'right',
        sortable: true,
        minWidth: 200,
        color: palette.primary.text,
        fontWeight: 500
    },
    {
        label: 'Project category',
        id: ValColumnEnum.project_type_1,
        align: 'left',
        sortable: true,
        minWidth: 250,
        color: palette.primary.text,
        fontWeight: 500
    },
    {
        label: 'Customer name',
        id: ValColumnEnum.customer_name,
        align: 'left',
        sortable: true,
        minWidth: 250,
        color: palette.primary.text,
        fontWeight: 500
    },
    {
        label: 'Status',
        id: ValColumnEnum.status,
        align: 'left',
        minWidth: 100,
        sortable: true,
        format: (val, _idx, row) => {
            var _a;
            return (_jsxs(Stack, { display: "flex", flexDirection: "row", alignItems: "center", textTransform: "capitalize", children: [_jsx(FiberManualRecord, { style: {
                            color: val === 'validated' ? '#4CAC4D' : val === 'uploaded' ? '#E47A18' : 'transparent',
                            marginRight: '6px'
                        } }), val, ((_a = row === null || row === void 0 ? void 0 : row[ValColumnEnum.dwg_path]) === null || _a === void 0 ? void 0 : _a.trim()) && (_jsx(Tooltip, { title: "Download Drawing", children: _jsx(SaveAlt, { style: { color: '#349cf4', marginLeft: '6px', cursor: 'pointer' }, onClick: e => handleDwgDownload(row, e) }) }))] }));
        },
        color: palette.primary.text,
        fontWeight: 500
    }
];
